import ResizeObserver from 'resize-observer-polyfill';

export class DomUtils {
  static onResize(element: HTMLElement, fn: ResizeObserverCallback) {
    new ResizeObserver(fn).observe(element);
  }
}
